const searchList = document.querySelector('.search-results');

if (searchList) {
  // Get the URL search parameters from URL
  const params = new URLSearchParams(window.location.search);
  const searchValue = params.get('searchTerm') || '';

  // Axios get paginated post list
  const axiosGetPaginatedSearchList = async (pageNumber = '1', searchTerm = '') => {
    const formDataInput = {
      action: 'getSearchList',
      pageNumber,
      searchTerm,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      const searchListRow = searchList.querySelector('.search-results__list');
      const searchNotFound = searchList.querySelector('.search-results__not-found-post-text');

      if (searchNotFound && data.data.not_found) {
        searchListRow.innerHTML = '';
        searchNotFound.classList.remove('hide');
      } else {
        searchNotFound.classList.add('hide');
      }

      if (searchListRow && data.data.html_list) {
        searchListRow.innerHTML = data.data.html_list;
      }

      const searchListFooter = searchList.querySelector('.search-results__pagination');
      if (searchListFooter && data.data.html_pagination) {
        searchListFooter.innerHTML = data.data.html_pagination;
        searchList.scrollIntoView();
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['searchTerm', 'pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }
  };

  // Pagination
  attachEvent('.search-results .pagination .page-numbers', 'click', (e) => {
    e.preventDefault();

    if (searchValue) {
      axiosGetPaginatedSearchList(e.target.dataset.page ?? e.target.closest('.page-numbers').dataset.page, searchValue);
    }
  });
}
